import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["textContent"]

import { computed, onMounted, ref, Ref } from 'vue';
import Chip from 'primevue/chip';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import ArchiveSwitch from '@/components/ArchiveSwitch';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { useArchiveStore, useSchoolAdminStore } from '@/store';
import { SchoolAdminModal, SchoolAdminTable } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';


export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolAdminsTable',
  setup(__props) {

const schoolAdminStore = useSchoolAdminStore();
const archiveStore = useArchiveStore();
const schoolAdmins: Ref<SchoolAdminTable[]> = ref([]);
const schoolAdminCount: Ref<number> = computed(() => (schoolAdmins.value ? schoolAdmins.value.length : 0));
const schoolAdminModalOpen: Ref<boolean> = ref(false);
const archivedVisible = ref(false);
const schoolAdminItems: Ref<SchoolAdminModal[]> = ref([]);

onMounted((): void => {
  if (can([PERMISSIONS.ORGANIZATION_SCHOOL_ADMIN_INDEX])) getSchoolAdmins(false);
});

const getSchoolAdmins: (showArchived: boolean) => Promise<void> = async (showArchived: boolean) => {
  const filterArchived = showArchived ? '?archived=1' : '';
  await schoolAdminStore
    .getSchoolAdminsForTable(filterArchived)
    .then((result) => (schoolAdmins.value = result))
    .catch((e) => {
      schoolAdmins.value = [];
      throw e;
    });
};

const createMenuModel = (item: SchoolAdminTable) => {
  const menuItems = [
    {
      label: 'Remove School Admin',
      visible: can([PERMISSIONS.ORGANIZATION_DETACH_SCHOOL_ADMINS]),
      command: () => {
        detachSchoolAdmin([item.id], item.name);
      },
    },
  ];
  if (item.archived) {
    menuItems.push({
      label: 'Unarchive',
      visible: can([PERMISSIONS.PEOPLE_ARCHIVE]),
      command: async () => {
        await archiveStore.unarchive(item.id);
        archiveStore.doToast(`${item.name} has been restored`, 'Unarchived');
      },
    });
  }
  return menuItems;
};

const attachSchoolAdmins: (ids: number[]) => Promise<void> = async (ids) => {
  await schoolAdminStore.attachSchoolAdmins(ids);
  getSchoolAdmins(false);
  schoolAdminStore.doToast('School Admin(s) has been added', 'Added');
};

const detachSchoolAdmin: (ids: number[], schoolAdminName: string) => Promise<void> = async (ids, schoolAdminName) => {
  await schoolAdminStore.detachSchoolAdmins(ids);
  getSchoolAdmins(false);
  schoolAdminStore.doToast(`${schoolAdminName} has been removed from organization`, 'Removed');
};

const openAddSchoolAdminModal = async () => {
  schoolAdminModalOpen.value = true;
  schoolAdminItems.value = await schoolAdminStore.getSchoolAdminsAvailableToAdd();
};

const onCancelAdd = () => (schoolAdminModalOpen.value = false);

const onSaveAdd = (schoolAdmins: SchoolAdminModal[]) => {
  let schoolAdminIds = schoolAdmins.map((schoolAdmins) => {
    return schoolAdmins.value;
  });
  attachSchoolAdmins(schoolAdminIds);
  schoolAdminModalOpen.value = false;
};
const showArchived = () => {
  archivedVisible.value = true;
  schoolAdminStore.showArchived = true;
  getSchoolAdmins(true);
};
const hideArchived = () => {
  archivedVisible.value = false;
  schoolAdminStore.showArchived = false;
  getSchoolAdmins(false);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "School Admins", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(schoolAdminCount.value), 1)
        ]),
        _: 1
      }),
      (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SCHOOL_SHOW_ARCHIVED]))
        ? (_openBlock(), _createBlock(_unref(ArchiveSwitch), {
            key: 0,
            onEnable: showArchived,
            onDisable: hideArchived
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_SCHOOL_ADMINS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add School Admin",
              "icon-left": "add",
              onClick: openAddSchoolAdminModal
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: schoolAdmins.value,
        "global-filter-fields": ['name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        "row-class": ({ archived }) => (archived ? 'grey-row' : null),
        loading: _unref(schoolAdminStore).loading,
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-store-school-admin-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': _unref(schoolAdminStore).loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("School Admins not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (schoolAdminCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "School Admin Name",
                  "header-style": "color: #3B4242",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.archived)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Icon, {
                          key: 0,
                          name: "info",
                          class: "mr-1 text-color-gray-dark text-base cursor-pointer"
                        }, null, 512)), [
                          [
                            _directive_tooltip,
                            {
                  value: 'Archived',
                  escape: true,
                  fitContent: true,
                },
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(can)([_unref(PERMISSIONS).PEOPLE_INDEX]))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          to: `/user/${data.id}`,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.name)
                        }, null, 8, ["to", "textContent"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.name)
                        }, null, 8, _hoisted_2))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  "body-style": "justify-content: center; font-size: .8725rem; max-width: 10rem;",
                  "header-style": "justify-content: center; max-width: 10rem",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_ActionMenu, {
                      "menu-items": createMenuModel(data),
                      icon: "more_horiz"
                    }, null, 8, ["menu-items"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "row-class", "loading", "class"]),
      (schoolAdminModalOpen.value && _unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_SCHOOL_ADMINS]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add school admins",
            items: schoolAdminItems.value,
            searchable: true,
            "button-text": "Add school admins",
            placeholder: "Search school admins",
            "person-type": "School admin",
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})